const colors = {
    green: '#4CAF50',
    red: '#DB190C',
    purple: '#3f1f5f',
    blue: '#7d6bd6',
    white: '#fff',
    orange: '#3f1f5f'
}

export default colors;